
export default {
  name: 'EnerDownloadFloatingButton',
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen
    },
    handleClickOutside () {
      if (this.isOpen === true) {
        this.isOpen = false
      }
    }
  }
}
